import { Route, Routes } from 'react-router-dom';
import CustomerProfileEdit from '@features/workspace/views/company/edit-profile';
import CustomerProfileView from '@features/workspace/views/company/view';
import Layout from '@features/workspace/components/layouts/v1/layout';
import NoteEdit from '@features/workspace/views/company/notes/edit';
import NoteCreate from '@features/workspace/views/company/notes/create';
import UserEdit from '@features/workspace/components/users/edit';
import UserCreate from '@features/workspace/components/users/create';
import { UserManagementMode } from '@features/workspace/components/users/utils/constants';
import { FC } from 'react';

const CustomerProfilePage: FC<any> = () => {
  return (
    <Layout>
      <Routes>
        <Route
          element={
            <UserEdit
              backUri="/customer/company#auth-persons"
              type="auth-person"
            />
          }
          path="/auth-persons/:user_id/edit"
        />
        <Route
          element={
            <UserCreate
              backUri="/customer/company#auth-persons"
              type={UserManagementMode.AuthPerson}
            />
          }
          path="/auth-persons/create"
        />
        <Route
          element={
            <UserEdit
              backUri="/customer/company#directors"
              type={UserManagementMode.Director}
            />
          }
          path="/directors/:user_id/edit"
        />
        <Route
          element={
            <UserCreate backUri="/customer/company#directors" type="director" />
          }
          path="/directors/create"
        />
        <Route element={<NoteEdit />} path="/notes/:note_id/edit" />
        <Route element={<NoteCreate />} path="/notes/create" />
        <Route element={<CustomerProfileEdit />} path="/edit" />
        <Route element={<CustomerProfileView />} path="/" />
      </Routes>
    </Layout>
  );
};

export default CustomerProfilePage;
